export default __webpack_public_path__ + "static/media/ardr.52b55437.svg";